module.exports = __webpack_public_path__ + "img/award-shadow.b72290ef.png";